module.exports = __webpack_public_path__ + "static/img/guaduan2.00ac8e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/guaduan2.png
// module id = YXrJ
// module chunks = 24